<template>
  <Multiselect
    class="tags-select component"
    select-label=""
    selected-label=""
    deselect-label=""
    @select="onSelect"
    @remove="onRemove"
    hideSelected
    :close-on-select="false"
    :multiple="true"
    :value="selected"
    :options="options"
    :loading="loading"
    :allow-empty="true"
    :label="'label'"
    placeholder="Add tag"
    track-by="id">

    <template slot="tag" slot-scope="props">
      <span class="ws-tag"><span>{{ props.option.label }}</span>
        <span class="remove" @click="props.remove(props.option)"></span>
      </span>
    </template>

    <template slot="option" slot-scope="props">
      <div class="option-item">{{ props.option.label }}</div>
    </template>

    <template slot="noResult"><span>Nothing here</span></template>
  </Multiselect>
</template>

<script type="text/babel">
  import * as tagsApi from '../services/tags.service'
  import Multiselect from 'vue-multiselect'

  export default {
    name: 'TagsSelect',
    components: { Multiselect },
    props: {
      selectedIds: {
        type: Array,
        'default': () => ([])
      }
    },
    data () {
      return {
        loading: false,
        selected: [],
        options: []
      }
    },
    methods: {
      processOptions (data) {
        return data.map(item => ({ ...item, label: item.name }))
      },
      fetch () {
        this.loading = true
        tagsApi.getList()
          .then(response => {
            this.options = this.processOptions(response.data.content)
          })
          .catch(error => {
            console.log('error', error)
          })
          .finally(() => { this.loading = false })
      },
      onSelect (selectedOption, id) {
        if (!this.selected.find(item => item.id === selectedOption.id)) {
          this.selected.push(selectedOption)
          this.$emit('select', selectedOption)
        }
      },
      onRemove (removedOption) {
        this.selected = this.selected.filter(item => item.id !== removedOption.id)
        this.$emit('remove', removedOption, this.selected)
      }
    },
    watch: {
      selectedIds (newValue, oldValue) {
        this.selected = this.processOptions(newValue)
      }
    },
    mounted () {
      this.fetch()
    }
  }
</script>

<style lang="scss">
  .multiselect.tags-select.component {
      position: relative;
      padding: 5px 0;
      width: 100%;
      background-color: #333333;
      &.multiselect--active{
        input.multiselect__input {
          width: 100% !important;
        }
      }

      .multiselect__content-wrapper {
        width: 100%;
        overflow-y: auto;
        position: absolute;
        background-color: #333333;
        .multiselect__content {
          width: 100%;
        }
      }

      .multiselect__tags {
        .multiselect__tags-wrap{
          display: flex;
          flex-wrap: wrap;

          .ws-tag {
            display: flex;
            align-items: center;
            border: 2px solid $color-body;
            border-radius: 3px;
            padding: 3px;
            margin: 2px;
            color: $color-body;
            &:hover{
              background-color: rgba(255, 255, 255, .05);
            }
            .remove {
              @include icon-remove;
              cursor: pointer;
              margin-left: 5px;
            }
          }
        }
      }

      .option-item {
        padding: 10px;
        cursor: pointer;
        width: 100%;
        &:hover{
          background-color: $color-body;
        }
      }
    }
</style>

<style lang="scss">

  .ws-tags-select .multiselect__tag {

  }
</style>




// WEBPACK FOOTER //
// src/components/TagsSelect.vue